module.exports = __webpack_public_path__ + "img/img1.1dd99300.png";